const MonthsKeys = {
    jan: "common.month.january",
    feb: "common.month.february",
    mar: "common.month.march",
    apr: "common.month.april",
    may: "common.month.may",
    june: "common.month.june",
    july: "common.month.july",
    aug: "common.month.august",
    sept: "common.month.september",
    oct: "common.month.october",
    nov: "common.month.november",
    dec: "common.month.december",
};

// we cant use the 'MonthsKeys' objects with substring because months like 'september' -> 'sept' and foreign languages support.
export const ShortenedMonthsKeys = {
    jan: "common.month.january.short",
    feb: "common.month.february.short",
    mar: "common.month.march.short",
    apr: "common.month.april.short",
    may: "common.month.may.short",
    june: "common.month.june.short",
    july: "common.month.july.short",
    aug: "common.month.august.short",
    sept: "common.month.september.short",
    oct: "common.month.october.short",
    nov: "common.month.november.short",
    dec: "common.month.december.short",
};
